// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { useNavigate, useParams } from 'react-router-dom';
import { Container, Header, Button, Icon } from 'semantic-ui-react';
import ProviderConfigSection from '../components/ProviderConfigSection';

function BrokerageProvidersPage() {
  const navigate = useNavigate();
  const { brokerageId } = useParams<{ brokerageId: string }>();

  const handleProviderSelect = (providerId: string) => {
    navigate(`/brokerages/${brokerageId}/providers/${providerId}/policy-types`);
  };

  return (
    <Container style={{ padding: '2rem' }}>
      <Button onClick={() => navigate(`/brokerages/${brokerageId}/edit`)}>
        <Icon name='arrow left' />
        Back to Brokerage
      </Button>

      <Header as='h1' style={{ marginTop: '1rem' }}>
        <Icon name='building' />
        <Header.Content>
          Provider Configuration
          <Header.Subheader>Manage providers and email overrides for this brokerage</Header.Subheader>
        </Header.Content>
      </Header>

      <ProviderConfigSection
        brokerageId={brokerageId!}
        onProviderSelect={handleProviderSelect}
      />
    </Container>
  );
}

export default BrokerageProvidersPage;
